import {filter, map} from 'lodash';

const state = () => ({
   freetext: null,
   exact: false,
   domain: {},
   level: {},
   education: {},
   competency: {},
   // initial collapsed state for each defined section
   collapsedState: {
      'filter-competencies': 1,
      'filter-other': 0,
      'filter-level': 0,
      'filter-education': 0,
      'filter-domains': 0,
   },
});

const getters = {
   selectedDomains: state => filter(state.domain, domain => domain.checked),
   selectedLevels: state => filter(state.level, level => level.checked),
   selectedEducation: state => filter(state.education, education => education.checked),
   selectedCompetencies: state => filter(state.competency, competency => competency.checked),
   filterParams: (state, getters) => {
      return {
         jobDomain: map(getters.selectedDomains, 'id'),
         jobLevel: map(getters.selectedLevels, 'id'),
         education: map(getters.selectedEducation, 'id'),
         competency: map(getters.selectedCompetencies, 'id'),
      };
   },
   allParams: (state, getters) => {
      return {
         text: state.freetext,
         exact: state.exact,
         ...getters.filterParams,
      };
   },
   noFilters: (state, getters) =>
      !getters.selectedDomains.length &&
      !getters.selectedLevels.length &&
      !getters.selectedEducation.length &&
      !getters.selectedCompetencies.length,
   empty: (state, getters) => !state.freetext && getters.noFilters,
   collapsedState: state => state.collapsedState,
};

const actions = {};

const mutations = {
   setFreetext(state, {text}) {
      state.freetext = text;
   },
   setExact(state, {exact}) {
      state.exact = exact;
   },
   setCheckState(state, {group, id, val}) {
      state[group][id].checked = val;
   },
   clearAll(state) {
      state.freetext = null;
      state.exact = false;
      Object.keys(state.domain).forEach(key => {
         state.domain[key].checked = false;
      });
      Object.keys(state.level).forEach(key => {
         state.level[key].checked = false;
      });
      Object.keys(state.education).forEach(key => {
         state.education[key].checked = false;
      });
      Object.keys(state.competency).forEach(key => {
         state.competency[key].checked = false;
      });
   },
   setCollapsedState(state, {id, val}) {
      state.collapsedState[id] = val;
   },
};

export default {
   namespaced: true,
   state,
   getters,
   actions,
   mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/filters.js